import { createRequestBus } from '@utils/requestBus'
import {
  receptionChatService,
  type ChatConversationResponse,
  type ConversationSummary,
} from './receptionChatService'

/**
 * Writes are serialized (start/send must not overlap).
 * Reads use a separate queue so sync polls are not blocked behind a slow POST (avoids 499 + frozen UI).
 */
const WRITE_BUS_KEY = 'reception-chat-write'
const READ_BUS_KEY = 'reception-chat-read'
const bus = createRequestBus()

export const receptionChatBus = {
  start: (message: string, createdBy?: string): Promise<ChatConversationResponse> =>
    bus.enqueue(WRITE_BUS_KEY, () => receptionChatService.start(message, createdBy)),

  sendMessage: (
    conversationId: number,
    message: string,
    createdBy?: string
  ): Promise<ChatConversationResponse> =>
    bus.enqueue(WRITE_BUS_KEY, () =>
      receptionChatService.sendMessage(conversationId, message, createdBy)
    ),

  startScheduling: (scheduledAt: string, createdBy?: string): Promise<ChatConversationResponse> =>
    bus.enqueue(WRITE_BUS_KEY, () =>
      receptionChatService.startScheduling(scheduledAt, createdBy)
    ),

  getConversation: (conversationId: number): Promise<ChatConversationResponse> =>
    bus.enqueue(READ_BUS_KEY, () => receptionChatService.getConversation(conversationId)),

  updateStatus: (
    conversationId: number,
    status: 0 | 1,
    changedBy?: string
  ): Promise<ChatConversationResponse> =>
    bus.enqueue(WRITE_BUS_KEY, () =>
      receptionChatService.updateStatus(conversationId, status, changedBy)
    ),

  listDrafts: (): Promise<ConversationSummary[]> => receptionChatService.listDrafts(),

  deleteDraft: (conversationId: number): Promise<void> =>
    bus.enqueue(WRITE_BUS_KEY, () => receptionChatService.deleteDraft(conversationId)),
}
